import {PageEmphasisText} from "./PWMTypography";
import {Box} from "@mui/material";
import React from "react";

const Variants = {
  success: {
    backgroundColor: '#14B8A6',
    color: '#ffffff'
  },
  warning: {
    backgroundColor: '#D14343',
    color: '#ffffff'
  },
  info: {
    backgroundColor: '#2196F3',
    color: '#ffffff'
  },
  error: {
    backgroundColor: '#D14343',
    color: '#ffffff'
  }
}
export const PWMTextBanner: React.FC<IPWMTextBannerProps> = (props) => {
  const variantStyles = Variants[props.variant ?? 'info'];
  return (
    <Box sx={{
      p: 1.2,
      textAlign: 'center',
      my: 1.2,
      border: '1px solid grey',
      mx: 'auto',
      width: props.fullWidth ? '100%' : '85%',
      borderRadius: '5px',
      ...variantStyles
    }}>
      <PageEmphasisText>{props.text}</PageEmphasisText>
    </Box>
  );
}

interface IPWMTextBannerProps {
  children?: React.ReactNode
  text: string;
  variant?: 'success' | 'warning' | 'info' | 'error';
  fullWidth?: boolean;
}